// extracted by mini-css-extract-plugin
export default {"DemoBanner":"DemoBanner34HILeLJ-060"};